import styled from "styled-components";
import Link from "next/link";

import {
  BREAKPOINT,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  paragraphStyles,
  TableCell,
  TableHeaderCell,
} from "../../constants/Styles";

const subHeaderStyles = `
  margin: 1rem 0;
  font-family: ${FONTS.spaceGrotesk};
`;

const listItemStyles = `
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight400};
  line-height: 1.5rem;
`;

const header1Styles = `
  color: ${COLORS.secondary};
  font-size: ${FONT_SIZE.size64};
  font-weight: ${FONT_WEIGHT.weight700};
  font-family: ${FONTS.spaceGrotesk};
  margin-bottom: 2rem;
  @media (max-width: ${BREAKPOINT}) {
      font-size: ${FONT_SIZE.size32};
  }
`;

const header2Styles = `
  color: ${COLORS.secondary};
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size32};
  font-weight: ${FONT_WEIGHT.weight500};
  margin: 2rem 0;
  @media (max-width: ${BREAKPOINT}) {
      font-size: ${FONT_SIZE.size24};
  }
`;

const header3Styles = `
  margin: 1rem 0;
  font-weight: ${FONT_WEIGHT.weight500};
  font-size: ${FONT_SIZE.size24};
  font-family: ${FONTS.spaceGrotesk};
    @media (max-width: ${BREAKPOINT}) {
      font-size: ${FONT_SIZE.size18};
  }
`;

const spanStyles = `
    color: ${COLORS.secondary};
    font-weight: ${FONT_WEIGHT.weight500};
`;

const Header1 = styled.h1`
  ${header1Styles};
`;

const Header2 = styled.h2`
  ${header2Styles};
`;

const Header3 = styled.h3`
  ${header3Styles};
`;

const Header4 = styled.h4`
  ${subHeaderStyles};
`;

const Header5 = styled.h5`
  ${subHeaderStyles};
`;

const Header6 = styled.h6`
  ${subHeaderStyles};
`;

const Paragraph = styled.p`
  ${paragraphStyles};
`;

const Code = styled.code`
  color: ${COLORS.secondary};
  font-weight: ${FONT_WEIGHT.weight500};
  font-family: ${FONTS.spaceGrotesk};
`;

const BlockQuote = styled.div`
  padding: 0.5rem 1.5rem;
  margin: 1rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 0.25rem;
  border-left: 0.25rem solid ${COLORS.badgeGray};
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
    ${COLORS.tableBackground};

  > p {
    color: ${COLORS.secondary};
  }
`;

const UnorderedList = styled.ul`
  margin-left: 1rem;
  ${listItemStyles};
`;

const OrderedList = styled.ol`
  margin-bottom: 1rem;
  ${listItemStyles};
`;

const ListItem = styled.li`
  margin: 0 0 0.25rem 1rem;

  span,
  a {
    ${spanStyles};
  }
`;

const Table = styled.table`
  margin: 1rem 0;
`;

const Strong = styled.span`
  font-weight: ${FONT_WEIGHT.weight700};
`;

const Image = styled.img`
  margin: 0.5rem;
  max-width: 100%;
`;

const MarkdownLink = styled(Link)`
  text-align: left;
  margin-bottom: 3rem;
`;

const TableHeader = styled(TableHeaderCell)`
  font-size: ${FONT_SIZE.size14};
`;

const Cell = styled(TableCell)`
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export {
  Header1,
  Header2,
  Header3,
  Header4,
  Header5,
  Header6,
  Paragraph,
  Code,
  UnorderedList,
  OrderedList,
  ListItem,
  BlockQuote,
  Table,
  Strong,
  Image,
  MarkdownLink,
  subHeaderStyles,
  header1Styles,
  header2Styles,
  header3Styles,
  listItemStyles,
  spanStyles,
  TableHeader,
  Cell,
};
